import { oneOf, route } from "./index";

const WORKFLOW_PARAMS =
  "?branch=:branchId&commit=:commitId&step=:step&file=:file&connectingClaimId=:connectingClaimId&execution=:execution&run=:run&showRuns=:showRuns&view=:view&tab=:tab&browserStep=:browserStep&linkType=:linkType=all";

const SORT_PARAMS = "sort=:sort&dir=:dir";

const FEED_FILTERS = `status=:status=all&space=:space=all&app=:app=all&creator=:creator=all&${SORT_PARAMS}`;
const FEED_FILTERS_WITH_TRIGGER = `${FEED_FILTERS}&trigger=:trigger=all`;

const PAGE_FILTERS = "?show=:show=live&type=:type=all&sort=:sort";

export const rawRoutes = {
  root: route("/", {
    modal: oneOf({
      space: "id=:id&tab=:tab=settings",
      group: "id=:id&tab=:tab=settings",
      member: "id=:id&tab=:tab=membership",
      role: "id=:id",
      serviceAccount: "id=:id",
      network: "id=:id&tab=:tab=settings",
      aiProvider: "id=:id&tab=:tab=settings",
      admins: "",
      customizeNav: "",
      connector: "id=:id&tab=:tab=settings",
      storage:
        "spaceId=:spaceId&branchId=:branchId&workflowId=:workflowId&volume=:volume&section=:section",
      skill: "id=:id&tab=:tab=settings",
      oauthApp: "id=:id",
      workflowValue: "id=:id",
    }),
    home: route("/"),
    recents: route(`/recents?${FEED_FILTERS_WITH_TRIGGER}`, {
      links: route(`/links${PAGE_FILTERS}`),
    }),
    branches: route(`/branches?${FEED_FILTERS}&tab=:tab=branches`),
    favorites: route(`/favorites?${FEED_FILTERS_WITH_TRIGGER}`, {
      links: route(`/links${PAGE_FILTERS}`),
    }),
    personal: route(`/personal?${SORT_PARAMS}`, {
      links: route(`/links${PAGE_FILTERS}`),
      workflow: route(`/workflows/:workflowId${WORKFLOW_PARAMS}`),
    }),
    chats: route("/chats?tab=:tabId&userId=:userId&history=:history"),
    space: route(`/spaces/:spaceId?${FEED_FILTERS_WITH_TRIGGER}`, {
      links: route(`/links${PAGE_FILTERS}`),
      leaderboard: route("/leaderboard?sort=:sort=name&dir=:dir=asc"),
      workflow: route(`/workflows/:workflowId${WORKFLOW_PARAMS}`),
    }),
    // Path stays "/apps" so existing bookmarks keep resolving.
    connectors: route("/apps", {
      connected: route(
        `/connected?q=:q&status=:status=all&creator=:creator=all&${SORT_PARAMS}`
      ),
      directory: route(
        "/directory?q=:q&tag=:tag=all&justCreated=:justCreated",
        {
          create: route("/create?identifier=:identifier"),
        }
      ),
    }),
    skills: route("/skills", {
      list: route(`/list?q=:q&creator=:creator=all&${SORT_PARAMS}`),
      browse: route("/browse?q=:q&justCreated=:justCreated"),
    }),
    monitoring: route("/monitoring", {
      value: route("/value?window=:window=30"),
      workflows: route(
        "/workflows?sort=:sort=duration&routeSort=:routeSort=name"
      ),
      access: route("/access?node=:node"),
      ai: route("/ai"),
      connectors: route("/connectors?window=:window=30"),
    }),
    settings: route("/settings", {
      preferences: route("/preferences"),
      spaces: route(
        `/spaces?q=:q&show=:show=all&manager=:manager=all&member=:member=all&${SORT_PARAMS}`,
        {
          space: route("/:spaceId"),
        }
      ),
      members: route("/members", {
        users: route(
          `/users?q=:q&show=:show=active&group=:group=all&${SORT_PARAMS}`,
          {
            invite: route("/invite"),
          }
        ),
        serviceAccounts: route(`/service-accounts?q=:q&${SORT_PARAMS}`, {
          device: route("/device?user_code=:userCode"),
        }),
      }),
      userGroups: route(`/user-groups?q=:q&${SORT_PARAMS}`, {
        new: route("/new"),
      }),
      apiKeys: route(`/api-keys?${SORT_PARAMS}`),
      sso: route("/sso"),
      ai: route("/ai?configId=:configId&tab=:tab=settings", {
        new: route("/new?tab=:tab=settings&provider=:provider"),
      }),
      roles: route("/roles?q=:q&scope=:scope=space&sort=:sort=name", {
        new: route("/new?scopeKind=:scopeKind"),
      }),
      auditLogs: route("/audit-logs", {
        logs: route("/logs"),
        destinations: route("/destinations?destinationId=:destinationId", {
          new: route("/new"),
        }),
      }),
      featureFlags: route(`/feature-flags?${SORT_PARAMS}`),
      networking: route("/networking", {
        new: route("/new?tab=:tab=settings"),
        rules: route("/rules?ruleId=:ruleId", {
          new: route("/new"),
        }),
      }),
    }),
    watchtower: route("/watchtower"),
    version: route("/version"),
    credits: route("/credits"),
    authError: route(
      "/auth/error?error=:error&error_description=:error_description"
    ),
  }),
} as const;
